import {ElementStyles} from "./ElementStyles";

export default function NumberInputWeex({
                                          onChange,
                                          value,
                                          placeholder,
                                          mobile = false,
                                          style = null,
                                          label = null,
                                          light = false,
                                          ...props
                                        }){

  const styles = {
    container: {
      borderRadius: ElementStyles.borderRadius,
      boxSizing: "inherit",
      background: light ? ElementStyles.color3 : ElementStyles.color2,
      color: ElementStyles.color,
      padding: ElementStyles.paddingLabels,
      minHeight: ElementStyles.height,
      display: "flex",
      alignItems: "center",
      textWrap: "noWrap",
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "var(--white)"
    },
    input: {
      width: "calc(100% - 5px)",
      // background: ElementStyles.background,
      color: ElementStyles.color,
      border: "none",
      resize: "none",
      fontSize: 16
    },
    arrows: {
      boxShadow: "none",
      background: "white",
      border: "none"
    }
  };

  //https://vlad-ignatov.github.io/react-numeric-input/
  return (
    <div style={{position: "relative"}}>
      {label && value != null && <label style={{
        color: "var(--white)",
        position: "absolute",
        top: -8,
        zIndex: 1,
        left: 10,
        background: light ? "var(--darkgray)" : "var(--background)",
        paddingLeft: 3,
        paddingRight: 3
      }}>{label}</label>}
      <input type={"number"}
             value={value}
             onChange={e => onChange(e.target.value)}
             placeholder={placeholder}
             style={{...styles.container, ...style}} {...props}
      />
    </div>
  );
};

